"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServGa = void 0;
const goog_base_1 = require("./goog_base");
/**
 * Google Analytics
 */
class AnServGa extends goog_base_1.AnServGoogBase {
}
exports.AnServGa = AnServGa;
AnServGa.serviceName = "GoogleAnalytics";
